import React from 'react'

export interface RowTileProps {
  children: React.ReactNode
  style?: React.CSSProperties
}

/**
 * A surface-base card row with the standard 16px inset and rounded corners.
 * Shared chrome for list rows (region allocations, uploaded documents, …) so
 * their surface, padding and radius stay in lockstep. Pass the row's own layout
 * hint (e.g. `justifyContent` / `gap`) via `style`.
 */
export function RowTile({ children, style }: RowTileProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--spacing-4)',
        background: 'var(--color-surface-base)',
        borderRadius: 'var(--radius-md)',
        ...style,
      }}
    >
      {children}
    </div>
  )
}
